/** v1 `utils/searchInput.ts`: `#tag` and `#"multi word"` tokens are tags; the rest is the term. */
const tagPattern = /#(?:"([^"]+)"|([^#]+?))(?=\s|$)/g;

export const parseSearchInput = (
	input: string,
): Readonly<{ text: string; tags: ReadonlyArray<string> }> => {
	const tags = Array.from(
		new Set(
			Array.from(input.matchAll(tagPattern))
				.map((match) => (match[1] ?? match[2] ?? "").trim())
				.filter((tag) => tag !== ""),
		),
	);
	return {
		text: input.replace(tagPattern, "").replace(/\s+/g, " ").trim(),
		tags,
	};
};
